import SearchableCandidateSelectInner from './SearchableSelect';

/**
 * Thin wrapper around SearchableSelect for backward compatibility.
 * Prefer <SearchableSelect items=... /> in new code.
 */
export default function SearchableCandidateSelect({
  value,
  onChange,
  resumes = [],
  placeholder = 'Search candidate by name or position…',
  testId = 'candidate-select',
  disabled = false,
}) {
  return (
    <SearchableCandidateSelectInner
      value={value}
      onChange={onChange}
      items={resumes}
      getLabel={(r) => r.candidate_name || '(no name)'}
      getSublabel={(r) => [r.position_title, r.client_name].filter(Boolean).join(' · ')}
      getSearchText={(r) => `${r.candidate_name || ''} ${r.position_title || ''} ${r.client_name || ''}`}
      placeholder={placeholder}
      emptyLabel="Select a candidate"
      testId={testId}
      disabled={disabled}
    />
  );
}

